import { SNACKBAR_TYPES } from '@/utils/constants';

export default {
  name: 'ReimbursementCode',
  computed: {
    code() {
      const { code } = this.$route?.query || {};
      return code ? decodeURIComponent(code) : '';
    },
  },
  watch: {
    code(newVal) {
      this.generateQRCode(newVal);
    },
  },
  beforeDestroy() {
    document.querySelector('.app__container').classList.remove('qrcode');
  },
  mounted() {
    this.generateQRCode(this.code);

    document.querySelector('.app__container').classList.add('qrcode');
  },
  methods: {
    generateQRCode(code) {
      if (!code) {
        return;
      }
      this.$nextTick(() => {
        try {
          this.$qrCode.toCanvas(
            document.querySelector('#qrcode'),
            code,
            {
              margin: 1,
              width: 300,
            },
          );
        } catch (error) {
          const { message: msg } = error;
          this.$snackbar({
            type: SNACKBAR_TYPES.ERROR,
            msg,
          });
        }
      });
    },
  },
};
